import { clearOfflineCache } from '../lib/offline/syncQueue';
import { SAVED_ACCOUNTS_KEY } from './storageKeys';

/**
 * Limpa completamente os dados de sessão no browser.
 *
 * Observação: Senha de Acesso (WebAuthn) não fica no storage da aplicação,
 * então continua disponível no dispositivo mesmo após esta limpeza.
 */
export async function clearClientSession(): Promise<void> {
  let logoutReason: string | null = null;
  
  // Limpar banco IndexedDB offline
  try {
    await clearOfflineCache();
  } catch (e) {
    console.error('[SessionCleanup] Erro ao limpar caches offline:', e);
  }

  try {
    logoutReason = sessionStorage.getItem('ac_logout_reason') || localStorage.getItem('ac_logout_reason');
    sessionStorage.clear();
  } catch {
    // noop
  }

  try {
    // Preservar itens importantes e deletar o restante do localStorage
    const keysToPreserve = [SAVED_ACCOUNTS_KEY, 'ac_remember_email'];
    const keysToDelete: string[] = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        if (!keysToPreserve.includes(key) && !key.startsWith('ac_passkey_')) {
          keysToDelete.push(key);
        }
      }
    }
    
    keysToDelete.forEach(k => localStorage.removeItem(k));

    if (logoutReason) {
      sessionStorage.setItem('ac_logout_reason', logoutReason);
      localStorage.setItem('ac_logout_reason', logoutReason);
    }
  } catch {
    // noop
  }

  // Limpar caches do origin (requests/assets cacheados)
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {
    // noop
  }
}

